var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// Multivariate Dependencies
import React, { createRef } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
// Styles
import styled from 'styled-components';
/**
 * @deprecated Do not use legacy components anymore.
 */
var StyledReactResizeObserver = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .resize-observer-placeholder {\n    display: none;\n  }\n"], ["\n  .resize-observer-placeholder {\n    display: none;\n  }\n"])));
/**
 * @deprecated Do not use legacy components anymore.
 */
var ReactResizeObserver = /** @class */ (function (_super) {
    __extends(ReactResizeObserver, _super);
    function ReactResizeObserver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReactResizeObserver.prototype.componentDidMount = function () {
        var _this = this;
        var observer = new ResizeObserver(function (entries) {
            var targetEntry = entries[0];
            if (targetEntry) {
                var onResize = _this.props.onResize;
                if (onResize) {
                    onResize(targetEntry.contentRect, entries);
                }
            }
        });
        var observerRef = this.props.observerRef;
        observer.observe(observerRef.current.parentNode);
        this.observer = observer;
    };
    ReactResizeObserver.prototype.shouldComponentUpdate = function () {
        return false;
    };
    ReactResizeObserver.prototype.componentWillUnmount = function () {
        if (this.observer) {
            this.observer.disconnect();
        }
    };
    ReactResizeObserver.prototype.render = function () {
        var observerRef = this.props.observerRef;
        return React.createElement(StyledReactResizeObserver, { ref: observerRef, className: 'resize-observer-placeholder' });
    };
    return ReactResizeObserver;
}(React.Component));
export { ReactResizeObserver };
// @ts-ignore For this legacy component the 'defaultProps' can be ignored from TS check.
ReactResizeObserver.defaultProps = {
    observerRef: createRef(),
};
var templateObject_1;
//# sourceMappingURL=ReactResizeObserver.js.map